

















/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';

/* ----------------------------------------
    Modules
---------------------------------------- */

import kebabCase from 'lodash/kebabCase';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({
    props: {
        type: String
    },

    computed: {
        selected() {
            return this.call[this.type];
        },

        options() {
            return this.call[this.type].options;
        }
    },

    methods: {
        select: function(e) {
            const label = e.currentTarget.textContent;
            const input = e.currentTarget.previousSibling;

            this.$emit('selectOption', {
                type: this.type,
                content: label,
                value: input.value
            })
        },

        value: function(string) {
            return kebabCase(string);
        }
    }

})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class Options extends Vue {}

